import { useRef } from "react";
import BannerArea from "./BannerArea";
import '../../CSS/Estilo.css';

export default function DropZone ({ onChange, accept = ["*"] ,directory}){
    const inputRef = useRef(null);
  
    function handleClick(){
      inputRef.current.click();
    }
  
    function handleChange(ev){
      onChange(ev.target.files);
    }
  
    function handleDrop(files){
      onChange(files);
    }
  
    return (
      <div className={'wrapper'}>
        <BannerArea onClick={handleClick} onDrop={handleDrop} directory ={directory} />
          <input
          style={{display:'none'}}
          type= 'file'
          webkitdirectory = {directory ? 'webkitdirectory':null} // Hace posible la seleccion de directorios o no si es null
          aria-label={directory ? "Seleccionar directorio":"Seleccionar ficheros"}
          className={'formInput'}
          ref={inputRef}
          multiple="multiple"
          onChange={handleChange}
          accept={directory ?'.folder': accept.join(",")} //Acepta directorios o cualquier tipo de fichero
        />
      </div>
    );
  };